module.exports = __webpack_public_path__ + "static/cdFront-8a8342e2b7856791720dd335f713fbf9.png";